import React from 'react';
import { Link } from 'react-router-dom';
// import Header from '../component/common/Header';
// import LoginSection from '../component/home/LoginSection';
// import Footer from '../component/common/Footer';
import Loader from './../../component/common/Loader';
import logo from "./../../assets/images/logo.png";
import CONSTANT from './../../constant';
import { onChange, setError, validateForm } from './../../utils';
import { resetPassword } from './../../actions/AuthAction';
import queryString from "query-string";
import constant from './../../constant';
class ComponentName extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        const values = queryString.parse(this.props.location.search);
        this.state = {
            token: { name: 'token', value: values.token, },
            newPassword: { name: 'newPassword', value: '', error: '', isRequired: true },
            confirmPassword: { name: 'confirmPassword', value: '', error: '', isRequired: true },
            showLoader: false
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = CONSTANT.pageTitle.resetPassword;
    }

    render() {
        const { newPassword, confirmPassword, showLoader } = this.state;
        return (
            <>
                {/* new code  */}


                <div className="login-21">
                    <div className="container-fluid">
                        <div className="row login-box60">
                            <div className="col-lg-5 form-text">
                                <div className="info clearfix">
                                    <div className="animate-charcter">
                                        <img src={logo} alt="logo" />
                                    </div>
                                    <p>ई-आफ़िस पोर्टल / e-Office and Intranet Portal</p>
                                </div>
                            </div>
                            <div className="col-lg-7 align-self-center form-section">
                                <div className="form-inner">
                                    <h1>eOffice and Intranet Portal</h1>
                                    <form onSubmit={this.onSubmit}>
                                        <div className="form-group form-box">
                                            <input
                                                type="password"
                                                className={newPassword.error.length > 0 ? 'form-controll has-validation' : 'form-controll'}
                                                placeholder="New password"
                                                name={newPassword.name}
                                                value={newPassword.value}
                                                onChange={this.onChange}
                                            />
                                            <i className="flaticon-mail-2" />
                                        </div>
                                        <div className="form-group form-box">
                                            <input
                                                type="password"
                                                className={confirmPassword.error.length > 0 ? "form-controll has-validation" : "form-controll"}
                                                placeholder="Confirm password"
                                                name={confirmPassword.name}
                                                value={confirmPassword.value}
                                                onChange={this.onChange}
                                            />
                                            <i className="flaticon-password" />
                                        </div>
                                        <div className="form-group">
                                            <button type="submit" className="btn-md btn-theme w-100">
                                                Update Password
                                            </button>
                                        </div>
                                        <div className="extra-login form-group clearfix">
                                            <span>OR</span>
                                        </div>
                                        <div className="clearfix" />
                                        <div className="form-group">
                                            <Link className="btn-md btn-otp" to={constant.component.home.url}>Back to login</Link>
                                        </div>
                                    </form>
                                    <div className="clearfix" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* old code  */}
                {/* <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-4 offset-md-4">
                            <div className="card mt-5">
                                <div className="card-header">
                                    Reset password
                                </div>
                                <div className="card-body">
                                    <form onSubmit={this.onSubmit}>
                                        <div className="form-group">
                                            <label>New password</label>
                                            <input
                                                type="password"
                                                className={newPassword.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                placeholder="New password"
                                                name={newPassword.name}
                                                value={newPassword.value}
                                                onChange={this.onChange}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Confirm password</label>
                                            <input
                                                type="password"
                                                className={confirmPassword.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                placeholder="Confirm password"
                                                name={confirmPassword.name}
                                                value={confirmPassword.value}
                                                onChange={this.onChange}
                                            />
                                        </div>
                                        <div className="">{confirmPassword.error.length > 0 ? confirmPassword.error : ''}</div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <Link to={CONSTANT.component.login.url}>
                                                    Back to login
                                                </Link>
                                            </div>
                                            <div className="col-md-6">
                                                <button type="submit" className="btn btn-block submit-button btn-sm">Update Password</button>
                                            </div>
                                        </div>

                                    </form>
                                </div>

                            </div>
                        </div>

                    </div>
                    {
                        showLoader && <Loader />
                    }
                </div> */}
            </>
        )
    }

    onChange = (e: any) => {
        const name = e.target.name;
        const value = e.target.value;
        onChange(this, name, value);
    }

    onSubmit = (e: any) => {
        e.preventDefault();
        if (validateForm(this)) {
            // this.setState({ showLoader: true });


            const st = this.state;
            if (st.newPassword.value !== st.confirmPassword.value)
                setError(this, st.confirmPassword.name, 'Password not matched')
            if (st.token.value) {
                const model = {
                    newPassword: st.newPassword.value,
                    token: st.token.value
                };
                resetPassword(model).then((res: any) => {
                    this.setState({ showLoader: false });
                    if (res) {
                        if (res.status === CONSTANT.static.apiStatus.success) {
                            alert("Password updated successfully");
                            this.props.history.push(CONSTANT.component.home.url);
                        } else {
                            alert(res.error);
                        }
                    }
                });
            }
        }
    }
}

export default ComponentName;